import { useSelector } from 'react-redux';
import useNavigation from '../../../../hook/useNavigation';
import useScroll from '../../../../hook/useScroll';

const Name = (props) => {
	const { title, className } = props;
	const { isScrolled } = useScroll();
	const { details: outlet } = useSelector((store) => store?.outlet);

	return (
		<div className={`flex-1 min-w-0 transition-all duration-300 ${className} ${isScrolled ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform -translate-y-2'}`}>
			<h1 className='text-left text-gray-900 text-base font-semibold truncate max-w-[75vw]'>{title ?? outlet?.storeName}</h1>
		</div>
	);
};

export default Name;
